import React, { useState } from "react";
import { Button, Card, Input, Select } from "../../../common";
import { ReactComponent as Pen } from "../../../../assets/icons/pen.svg";
import { ReactComponent as Close } from "../../../../assets/icons/close-circle.svg";
import { ReactComponent as UserIcon } from "../../../../assets/icons/user.svg";
import { ReactComponent as EmailIcon } from "../../../../assets/icons/email.svg";
import { ReactComponent as CompanyIcon } from "../../../../assets/icons/auditFirm.svg";
import { useSelector, useDispatch } from "react-redux";
import { countryCodes } from "./countryCodes";
import {
  useUpdateUserMutation,
  useUpdateUserImageMutation,
} from "../../../../store/auth/usersApiSlice";
import { ReactComponent as Spinner } from "../../../../assets/icons/spinner.svg";
import { setUserInfo } from "../../../../store/auth/authSlice";
import { getShorthandName } from "../../../../utils/Helper";
import { uploadFilePath } from "../../../../constants/s3UploadPath";
import { uploadFileToS3 } from "../../../../utils/uploadFileToS3";
import PhoneNumberInput from "../../../common/PhoneNumberInput";

export const UserProfileForm = () => {
  const dispatch = useDispatch();
  const [error, setError] = useState(false);
  const [designationError, setDesignationError] = useState(false);
  const [employerCompanyNameError, setEmployerCompanyNameError] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const { userInfo, token } = useSelector((state) => state.auth);
  const [name, setName] = useState(userInfo?.name || "");
  const [designation, setDesignation] = useState(userInfo?.individual[0]?.designation || "");
  const [employer_company_name, setEmployerCompanyName] = useState(userInfo?.individual[0]?.employer_company_name || "");
  const [countryCode, setCountryCode] = useState(
    userInfo?.mobile_number?.split("|")[0] || "+971"
  );
  const [countryCodeAlt, setCountryCodeAlt] = useState(
    userInfo?.alternate_number?.split("|")[0] || "+971"
  );
  const [mobile, setMobile] = useState(
    userInfo?.mobile_number?.split("|")[1] || ""
  );
  const [alternateMobile, setAlternateMobile] = useState(
    userInfo?.alternate_number?.split("|")[1] || ""
  );

  const [updateUser, { isLoading }] = useUpdateUserMutation();
  const [updateUserImage, { isLoading: imageLoading }] =
    useUpdateUserImageMutation();

  const handleEditButtonClick = () => {
    setIsEditMode(true);
  };
  const handleUserInfoUpdate = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      setError(true);
      return;
    } else if (!designation.trim()) {
      setDesignationError(true);
      return;
    } else if (!employer_company_name.trim()) {
      setEmployerCompanyNameError(true);
      return;
    }

    const updatedMobile = mobile;
    const updatedMobileAlt = alternateMobile;

    const res = await updateUser({
      data: {
        name,
        mobile_number: updatedMobile,
        alternate_number: updatedMobileAlt,
        designation: designation,
        employer_company_name: employer_company_name
      },
      token,
    }).unwrap();
    if (res) {
      setEmployerCompanyNameError(false);
    }
    dispatch(setUserInfo({ ...res }));
    setIsEditMode(false);
    setError(false);
  };
  const [isValidMobileNumber, setIsValidMobileNumber] = useState(true);
  const handleCancelButtonClick = () => {
    setName(userInfo.name);
    setMobile(userInfo?.mobile_number || "");

    setAlternateMobile(userInfo?.alternate_number || "");
    setCountryCode(userInfo?.mobile_number?.split("|")[0] || "+971");
    setCountryCodeAlt(userInfo?.mobile_number?.split("|")[0] || "+971");
    setIsEditMode(false);
  };
  const handleFileSelect = async (e) => {
    if (e.target.files[0]) {
      setLoader(true);
      const formData = new FormData();
      const profilesUrl = await uploadFileToS3(
        uploadFilePath?.userProfile,
        e.target.files[0],
        token,
        // userInfo?.id
      );
      formData.append("profile_image", profilesUrl?.url);
      const res = await updateUserImage({
        data: formData,
        token,
      }).unwrap();
      if (res) {
        setTimeout(() => {
          setLoader(false);
        }, 100)
      }
      dispatch(setUserInfo({ ...res }));
    }
  };

  const handleFileRemove = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("profile_image", "");
    const res = await updateUserImage({
      data: formData,
      token,
    }).unwrap();
    dispatch(setUserInfo({ ...res }));
  };
  const handleEditClick = (e) => {
    e.preventDefault();
    const fileInput = document.getElementById("file-input");
    fileInput.click();
  };

  const handleKeyPress = (event) => {
    const key = event.key;
    if (event.keyCode !== 8 && (key < "0" || key > "9")) {
      event.preventDefault();
    }
  };

  return (
    <Card classes="w-full md:col-start-1 p-6 md:col-end-9 bg-white rounded-xl">
      <div className="flex  md:justify-between flex-col md:flex-row">
        <h4 className="text-primary text-f24 font-bold">User Profile</h4>
        {isEditMode ? (
          <Button
            onClick={handleCancelButtonClick}
            classes="text-primaryText font-semibold text-f16"
          >
            <Close /> Cancel
          </Button>
        ) : (
          <Button
            onClick={handleEditButtonClick}
            classes="text-primaryText font-semibold text-f16"
          >
            <Pen /> Edit Profile
          </Button>
        )}
      </div>
      <h5 className="text-primary text-f20 font-bold text-left pt-6">
        Personal Information
      </h5>
      {/* {JSON.stringify(userInfo?.individual[0]?.employer_company_name)}
      {JSON.stringify(userInfo?.individual[0]?.designation)} */}
      <form>
        <div className="grid md:grid-cols-12 sm:grid-rows-2 md:grid-rows-1 gap-8 mt-4">
          <div className="w-full md:col-start-1 md:col-end-9">
            <div className="flex items-start flex-col mb-6">
              <label className="text-primary text-f14 font-semibold">
                Full Name
              </label>
              <div className="relative w-full">
                <input
                  type="text"
                  className="w-full py-2 pl-9 border border-input rounded bg-input"
                  placeholder="Name"
                  value={!isEditMode ? userInfo.name : name}
                  readOnly={!isEditMode}
                  onChange={(e) => setName(e.target.value)}
                />
                <div className="absolute top-3 left-3">
                  <UserIcon />
                </div>
                {error && (
                  <div className="text-left text-red-600 mt-1">
                    Name can't be blank.
                  </div>
                )}
              </div>
            </div>
            <div className="flex items-start flex-col mb-6">
              <label className="text-primary text-f14 font-semibold">
                Email Address
              </label>
              <div className="relative w-full">
                <input
                  type="email"
                  className="w-full py-2 pl-9 border border-input rounded bg-inputDisable focus:outline-none outline-none"
                  placeholder="Email"
                  value={userInfo.email}
                  readOnly
                />
                <div className="absolute top-3 left-3">
                  <EmailIcon />
                </div>
              </div>
            </div>
          </div>
          <div className="w-full md:flex md:items-start md:space-x-6 md:col-start-1 md:col-end-9" style={{ "marginTop": "-35px" }}>
            <div className="flex flex-col mb-6 md:w-1/2">
              <label className="text-primary text-f14 text-left font-semibold">
                Designation
              </label>
              <div className="relative w-full">
                <input
                  type="text"
                  className="w-full py-2 pl-9 border border-input rounded bg-input"
                  placeholder="Name"
                  value={!isEditMode ? userInfo?.individual[0]?.designation : designation}
                  readOnly={!isEditMode}
                  onChange={(e) => setDesignation(e.target.value)}
                />
                <div className="absolute top-3 left-3">
                  <UserIcon />
                </div>
                {designationError && (
                  <div className="text-left text-red-600 mt-1">
                    Designation can't be blank.
                  </div>
                )}
              </div>
            </div>
            <div className="flex flex-col mb-6 md:w-1/2">
              <label className="text-primary text-f14 text-left font-semibold">
                Company Name
              </label>
              <div className="relative w-full">
                <input
                  type="text"
                  className="w-full py-2 pl-9 border border-input rounded bg-input"
                  placeholder="Name"
                  value={!isEditMode ? userInfo?.individual[0]?.employer_company_name : employer_company_name}
                  readOnly={!isEditMode}
                  onChange={(e) => setEmployerCompanyName(e.target.value)}
                />
                <div className="absolute top-3 left-3">
                  <CompanyIcon />
                </div>
                {employerCompanyNameError && (
                  <div className="text-left text-red-600 mt-1">
                    Company Name can't be blank.
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="flex items-center flex-col w-full md:col-start-9 md:col-end-13" style={{ "marginTop": "-42.5%" }}>
            {loader ?
              <div
                className="w-40 h-40 bg-lightPurple rounded-full flex items-center justify-center border-4 border-white shadow-md cursor-pointer"
              >
                <span className="relative">Loading</span>
                <span className="relative"><Spinner /></span>
              </div>
              :
              userInfo?.profile_image ? (
                <img
                  src={userInfo.profile_image}
                  alt="Profile"
                  onClick={handleEditClick}
                  className="w-40 h-40 rounded-full flex items-center justify-center border-4 border-white shadow-md object-cover cursor-pointer"
                />
              ) : (
                <div
                  onClick={handleEditClick}
                  className="w-40 h-40 bg-lightPurple rounded-full flex items-center justify-center border-4 border-white shadow-md cursor-pointer"
                >
                  <span
                    className={`text-profile ${getShorthandName(userInfo?.name || "").length > 2
                      ? "text-f40"
                      : "text-f62"
                      }`}
                  >
                    {getShorthandName(userInfo?.name || "")}
                  </span>
                </div>
              )}
            <input
              type="file"
              id="file-input"
              style={{ display: "none" }}
              onChange={handleFileSelect}
            />
            <div className="flex gap-4">
              <button
                className=" text-link mt-2 font-semibold"
                onClick={handleEditClick}
              >
                Edit
              </button>
              {userInfo.profile_image && (
                <button
                  className=" text-primary mt-2 font-semibold"
                  onClick={handleFileRemove}
                >
                  remove
                </button>
              )}
            </div>
          </div>
        </div>
        <hr className="w-full my-3" />
        <div className="flex flex-col w-full">
          <h5 className="text-primary text-f20 font-bold text-left pt-6">
            Contact Information (Optional)
          </h5>
          <div className="md:flex gap-4 mt-3 block md:items-end">
            <div className="flex items-start flex-col mb-6 md:w-1/2 w-full">
              <label className="text-primary text-f14 font-semibold">
                Mobile Number
              </label>
              <div className="relative w-full">
                <PhoneNumberInput
                  id="mobile"
                  phone={mobile}
                  border={true}
                  // onChange={(e) => setMobile(e.target.value)}
                  setPhone={setMobile}
                  verifyPhoneNumber={false}
                  classes={'addBackground'}
                  error={""}
                  readOnly={!isEditMode} />
                {/* <Input
                  type="text"
                  id="mobile"
                  className="w-full py-2 pl-[35%] border border-input rounded bg-inputDisable "
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  onKeyDown={handleKeyPress}
                  readOnly={!isEditMode}
                /> */}
              </div>
              {!isValidMobileNumber && (
                <p>Please enter a valid numeric digit mobile number.</p>
              )}
            </div>
            <div className="flex items-start flex-col mb-6 md:w-1/2 w-full">
              <label className="text-primary text-f14 font-semibold">
                Alternate mobile number (optional)
              </label>
              <div className="relative w-full">
                <PhoneNumberInput
                  id="mobile"
                  phone={alternateMobile}
                  border={true}
                  // onChange={(e) => setAlternateMobile(e.target.value)}
                  setPhone={setAlternateMobile}
                  verifyPhoneNumber={false}
                  classes={'addBackground'}
                  error={""}
                  readOnly={!isEditMode} />
                {/* <Input
                  type="text"
                  id="mobile"
                  className="w-full py-2 pl-[35%] border border-input rounded bg-inputDisable "
                  value={alternateMobile}
                  onChange={(e) => setAlternateMobile(e.target.value)}
                  onKeyDown={handleKeyPress}
                  readOnly={!isEditMode}
                /> */}
              </div>
            </div>
          </div>
        </div>
        {isEditMode && (
          <Button
            classes="w-full bg-primary py-3 rounded text-white mt-4"
            onClick={handleUserInfoUpdate}
          >
            {isLoading ? <Spinner /> : "Save changes"}
          </Button>
        )}
      </form>
    </Card>
  );
};
